import { ICommandBarItemProps } from '@fluentui/react';
import { IPText } from 'baseComponents';
import { IPStack } from 'baseComponents/Stack/IPStack';
import { globalTextStylesBold } from 'globalStyles';
import { isBrokeredProvider } from 'models/documentProvider';
import ResourceLink, { ResourceLinkVersion } from 'models/resourceLink';
import { UserReadConfirmation } from 'models/userReadConfirmation';
import { LinkPreviewBrokered } from './LinkPreviewBrokered';
import { LinkPreviewSharePoint } from './LinkPreviewSharePoint';
import { LinkPreviewVirtual } from './LinkPreviewVirtual';

export interface ILinkPreviewProps {
  link?: ResourceLink;
  confirmOpen?: boolean;
  enableLinks?: boolean;
  hideHelp?: boolean;
  hideId?: boolean;
  hideCommandbar?: boolean;
  hideHeader?: boolean;
  // hides the evidence-export commands (page and Word export render the same Export button); for
  // hosts where exporting the shown document makes no sense, e.g. the audit report on its own tab
  hideExport?: boolean;
  extraCommandBarButtons?: ICommandBarItemProps[];
  title?: string;
  onDocumentEditorOpenChange?: (isOpen: boolean) => void;
  onClose?: () => void;
  onConfirmed?: (usr: UserReadConfirmation) => void;
  onNext?: () => void;
  onVersionLoaded?: (versionInfo: ResourceLinkVersion) => void;
  unavailableText?: string;
}

export const LinkPreview = (props: ILinkPreviewProps) => {
  //
  // Main render
  //
  return (
    <IPStack verticalFill>
      {props.title && (
        <IPStack.Item styles={{ root: { paddingBottom: 20, paddingLeft: 20 } }}>
          <IPText block variant="large" styles={globalTextStylesBold}>
            {props.title}
          </IPText>
        </IPStack.Item>
      )}
      {props.link?.list.isVirtual ? (
        <LinkPreviewVirtual {...props} />
      ) : isBrokeredProvider(props.link?.list) ? (
        <LinkPreviewBrokered {...props} />
      ) : (
        <LinkPreviewSharePoint {...props} />
      )}
    </IPStack>
  );
};
